import React from 'react';



class Footer extends React.Component {
    render() {
        return (
            <React.Fragment>

                <footer>
                    <section className="footerContainer">
                        <div className="contactUs">
                            <h3>CONTACT US</h3>
                            <ul>
                                <li>704-333-3333</li>
                                <li>contact@zenhome.com</li>
                            </ul>
                        </div>
                        <div className="socialMedia">
                            <h3>STAY CONNECTED</h3>
                            <ul>
                                <li><a href="https://www.facebook.com/" aria-label="Facebook"><i className="fab fa-facebook fa-2x"
                                    aria-hidden="true"></i></a></li>
                                <li><a href="https://www.twitter.com/" aria-label="Twitter"><i className="fab fa-twitter fa-2x"
                                    aria-hidden="true"></i></a></li>
                                <li><a href="https://www.instagram.com/" aria-label="Instagram"><i className="fab fa-instagram fa-2x"
                                    aria-hidden="true"></i></a></li>
                            </ul>
                        </div>

                        <div className="quickLinks">
                            <h3>QUICK LINKS</h3>
                            <ul>
                                <li>About Us</li>
                                <li>Terms of Use</li>
                                <li>Privacy Policy</li>
                                <li>FAQs</li>
                            </ul>
                        </div>

                    </section>
                    <div className="copyright">
                        <p>© ZEN HOME</p>
                    </div>
                </footer>

            </React.Fragment>
        )

    }

}

export default Footer;